





















import Vue from "vue";
import moment from "moment";

interface State {
  emailBody: string | null;
}

export default Vue.extend({
  name: "SentEmailCard",
  props: {
    email: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  data: (): State => {
    return {
      emailBody: null
    };
  },
  methods: {
    formatTStoDate(date: string): string {
      const ts = new Date(date);
      const time = ts.getTime() / 1000;
      return moment.unix(time).format("MMM D YYYY, h:mm a");
    },
    selectEmail() {
      this.$emit("select", this.email);
    },
    fixQuotes(s: string) {
      // so for some reason emails sent through TeamBot stored the orgUnit name with quotes around it in the database
      // so until that is fixed I'm going to just strip them here
      return s.replaceAll('"', "");
    }
  },
  computed: {
    sent(): string {
      return moment(this.email.dateCreated).calendar();
    }
  }
});
